const FEATURES = [
  {
    icon: 'ri-speed-up-line',
    title: '极速加载',
    desc: '智能CDN加速与多节点分发，全国覆盖高速服务器，确保即点即播，告别缓冲等待。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '支持高清与超清多档清晰度，先进编码技术还原每一帧细节，畅享视觉盛宴。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '专业运营团队实时同步最新片源，新片速递、热剧追更、综艺动漫每周准时上线。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '桌面、平板、手机全设备兼容，自适应屏幕尺寸，随时随地流畅追剧不停歇。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全纯净',
    desc: 'HTTPS加密传输，无恶意弹窗，无强制广告，打造纯净安全的在线观影环境。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">观影优势</h2>
          <p className="mt-2 text-sm text-foreground-600">为什么千万用户选择天美影视在线追剧</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {FEATURES.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 text-center cursor-pointer"
            >
              <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${item.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}